class ErrorHandler {
    constructor(rules = []) {
        this.rules = rules;
        this.errors = {};
    }

    // addRule(rule) {

    // }

    checkRule(ruleKey, values) {
        const [key, field] = ruleKey.split('.');

        const [keyPart, keyIndex] = key.split('-');
        const [fieldPart, fieldIndex] = field.split('-');

        const realKey = `${keyPart}.${fieldPart}`;
        if (Object.prototype.hasOwnProperty.call(this.rules, realKey)) {
            const response = this.rules[realKey](values, parseInt(keyIndex, 10), parseInt(fieldIndex, 10));

            if (response !== true) {
                if (!Object.prototype.hasOwnProperty.call(this.errors, key)) {
                    this.errors[key] = {};
                }
                this.errors[key][field] = response;
                return true;
            } else {
                this.clear(ruleKey);

                return false;
            }
        }
    }

    clear(ruleKey = null) {
        const [key, field] = ruleKey.split('.');

        if (key !== null) {
            if (Object.prototype.hasOwnProperty.call(this.errors, key) && Object.prototype.hasOwnProperty.call(this.errors[key], field)) {
                delete this.errors[key][field];

                const keys = Object.keys(this.errors[key]);
                if (keys.length === 0) {
                    delete this.errors[key];
                }
            } else if (field === undefined) {
                delete this.errors[key];
            }
        } else {
            this.errors = {};
        }
    }

    getErrors() {
        return this.errors;
    }

    validate(values, overrideRules) {
        const ruleKeys = overrideRules || Object.keys(this.rules);

        ruleKeys.forEach((key) => {
            this.checkRule(key, values);
        });

        return this.getErrors();
    }
}

export default ErrorHandler;
